import { action } from "satcheljs";

/**
 * Params for canceling an in-flight Smart Schedule generation job.
 * teamId: optional explicit team id; if omitted the service/orchestrator will derive it from TeamStore.
 */
export interface ICancelSmartScheduleGenerationJobParams {
    teamId?: string;
    tagId?: string;
    jobId?: string;
}

/**
 * Action: cancelSmartScheduleGenerationJob
 * Dispatched when user confirms cancellation of the smart schedule generation process.
 */
export const cancelSmartScheduleGenerationJob = action(
    "CANCEL_SMART_SCHEDULE_GENERATION_JOB",
    (params: ICancelSmartScheduleGenerationJobParams = {}) => params
);

export default cancelSmartScheduleGenerationJob;